// extracted by mini-css-extract-plugin
module.exports = {"Partner":"Partner_Partner__bqI8r"};